import { render, staticRenderFns } from "./AutomaticKYC.vue?vue&type=template&id=9facab82&"
import script from "./AutomaticKYC.vue?vue&type=script&lang=js&"
export * from "./AutomaticKYC.vue?vue&type=script&lang=js&"
import style0 from "./AutomaticKYC.vue?vue&type=style&index=0&id=9facab82&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports